module.exports = __webpack_public_path__ + "img/NATURGY_120X35.f13ec7b9.png";